import { useAlternativeProducts } from "./useAlternativeProducts";
import { useDefinitionFeatures } from "./useDefinitionFeatures";
import { useProductOptions } from "./useProductOptions";

export function useHasBottomRootMenu() {
	const {
		hasFillablePhotoZonesInDefinition,
		hasFillableTextZonesInDefinition,
		areBackgroundsSupported,
		areTemplatesSupported,
		areDesignsSupported,
		arePageDesignsSupported,
	} = useDefinitionFeatures();

	const alternativeProducts = useAlternativeProducts();
	const productOptions = useProductOptions();

	return (
		(hasFillablePhotoZonesInDefinition ? 1 : 0) +
			(hasFillableTextZonesInDefinition ? 1 : 0) +
			(areBackgroundsSupported ? 1 : 0) +
			(areTemplatesSupported ? 1 : 0) +
			(areDesignsSupported ? 1 : 0) +
			(arePageDesignsSupported ? 1 : 0) +
			// products alternatives
			(alternativeProducts.isSuccess && alternativeProducts.alternativeProductsGroups?.length
				? 1
				: 0) +
			// product options
			(productOptions.isSuccess && productOptions.productOptionGroup ? 1 : 0) >
		1
	);
}
